import { Link } from '@tanstack/react-router'
import React from 'react'
import { User } from '../user'

type UserLinkProps = {
    id: User['id']
    name?: User['name']
} & React.DOMAttributes<HTMLAnchorElement>

export function UserLink({ id, name, children, ...rest }: UserLinkProps) {
    return (
        <Link
            to="/users/$userId"
            params={{
                userId: id,
            }}
            {...rest}
        >
            {name || children}
        </Link>
    )
}
